"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.certificatesFactory = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const dictionary_evidence_1 = require("../../composite/evidence/dictionary-evidence/dictionary-evidence");
const evidence_1 = require("../../composite/evidence/evidence");
const certificates_fields_1 = require("./certificates-fields");
const certificates_schema_1 = require("./certificates-schema");
function certificatesFactory({ url, exportTag, defaultSorts, }) {
    return function Actions() {
        const intl = react_intl_1.useIntl();
        const validationSchema = certificates_schema_1.useValidationSchema();
        const evidence = dictionary_evidence_1.useDictionaryEvidence({
            identifier: 'CERTIFICATES',
            apiProps: {
                url,
            },
            tableProps: {
                tableName: intl.formatMessage({
                    id: 'EAS_CERTIFICATES_TABLE_TITLE',
                    defaultMessage: 'Certifikáty',
                }),
                reportTag: exportTag,
                defaultSorts,
            },
            detailProps: {
                FieldsComponent: certificates_fields_1.CertificateFields,
                validationSchema,
            },
        });
        return react_1.default.createElement(evidence_1.Evidence, Object.assign({}, evidence));
    };
}
exports.certificatesFactory = certificatesFactory;
//# sourceMappingURL=certificates.js.map